module.exports = __webpack_public_path__ + "img/dab_secretariat.069699fb.jpg";